import React from 'react'
import { colors } from '@/constants/colors'
import { useSafeTrack } from '@/utils/analytics'
import { useTranslate } from '@/utils/translate/translate-client'
import { useHlsPlayerUI } from './HlsPlayerUIContext'
import { HlsTooltip } from './HlsTooltip'

const OXIDE_BRIGHT = colors['oxide-bright']

/** Parental controls icon (enabled) — Bitmovin parental-controls-on.svg (teal people group). */
const ParentalControlsOnIcon: React.FC = () => (
  <svg width={24} height={17} viewBox="0 0 22 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M16.5 10.5C15.744 10.5 15.096 10.231 14.558 9.692C14.019 9.154 13.75 8.506 13.75 7.75C13.75 6.994 14.019 6.346 14.558 5.808C15.096 5.269 15.744 5 16.5 5C17.256 5 17.904 5.269 18.442 5.808C18.981 6.346 19.25 6.994 19.25 7.75C19.25 8.506 18.981 9.154 18.442 9.692C17.904 10.231 17.256 10.5 16.5 10.5ZM11 16V14.075C11 13.685 11.1 13.327 11.301 13.001C11.501 12.674 11.768 12.425 12.1 12.253C12.81 11.898 13.532 11.632 14.266 11.454C14.999 11.276 15.744 11.188 16.5 11.188C17.256 11.188 18.001 11.276 18.734 11.454C19.468 11.632 20.19 11.898 20.9 12.253C21.232 12.425 21.499 12.674 21.699 13.001C21.9 13.327 22 13.685 22 14.075V15C22 15.552 21.552 16 21 16H11Z"
      fill={OXIDE_BRIGHT}
    />
    <path
      d="M8 9C9.1 9 10.183 9.129 11.25 9.388C11.769 9.513 12.285 9.67 12.796 9.858C13.017 9.939 13.003 10.255 12.781 10.334C12.324 10.497 11.873 10.689 11.429 10.911L11.411 10.921C10.903 11.184 10.481 11.555 10.156 12.014L10.023 12.216C9.675 12.783 9.5 13.413 9.5 14.075V16H1C0.448 16 0 15.552 0 15V13.2C0 12.634 0.146 12.113 0.438 11.638C0.729 11.163 1.116 10.8 1.6 10.55C2.633 10.033 3.683 9.646 4.75 9.388C5.817 9.129 6.9 9 8 9Z"
      fill={OXIDE_BRIGHT}
    />
    <path
      d="M8 0C9.1 0 10.042 0.391 10.825 1.175C11.609 1.958 12 2.9 12 4C12 5.1 11.609 6.042 10.825 6.825C10.042 7.609 9.1 8 8 8C6.9 8 5.958 7.609 5.175 6.825C4.392 6.042 4 5.1 4 4C4 2.9 4.392 1.958 5.175 1.175C5.958 0.391 6.9 0 8 0Z"
      fill={OXIDE_BRIGHT}
    />
  </svg>
)

/** Parental controls icon (disabled) — Bitmovin parental-controls-off.svg (white people group). */
const ParentalControlsOffIcon: React.FC = () => (
  <svg width={24} height={17} viewBox="0 0 22 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M16.5 10.5C15.744 10.5 15.096 10.231 14.558 9.692C14.019 9.154 13.75 8.506 13.75 7.75C13.75 6.994 14.019 6.346 14.558 5.808C15.096 5.269 15.744 5 16.5 5C17.256 5 17.904 5.269 18.442 5.808C18.981 6.346 19.25 6.994 19.25 7.75C19.25 8.506 18.981 9.154 18.442 9.692C17.904 10.231 17.256 10.5 16.5 10.5ZM11 16V14.075C11 13.685 11.1 13.327 11.301 13.001C11.501 12.674 11.768 12.425 12.1 12.253C12.81 11.898 13.532 11.632 14.266 11.454C14.999 11.276 15.744 11.188 16.5 11.188C17.256 11.188 18.001 11.276 18.734 11.454C19.468 11.632 20.19 11.898 20.9 12.253C21.232 12.425 21.499 12.674 21.699 13.001C21.9 13.327 22 13.685 22 14.075V15C22 15.552 21.552 16 21 16H11Z"
      fill="white"
    />
    <path
      d="M1 16C0.448 16 0 15.552 0 15V13.2C0 12.634 0.146 12.113 0.438 11.638C0.729 11.163 1.116 10.8 1.6 10.55C2.633 10.033 3.683 9.646 4.75 9.388C5.817 9.129 6.9 9 8 9C9.1 9 10.183 9.129 11.25 9.388C11.734 9.505 12.215 9.65 12.692 9.82C13 10 13 10.254 12.692 10.366L12.373 10.488C12.055 10.615 11.74 10.755 11.429 10.911L11.411 10.921C10.903 11.184 10.481 11.555 10.156 12.014L10.023 12.216C9.675 12.783 9.5 13.413 9.5 14.075V16H1ZM10 4C10 3.434 9.822 3 9.411 2.589C9 2.178 8.566 2 8 2C7.434 2 7 2.178 6.589 2.589C6.178 3 6 3.434 6 4C6 4.566 6.178 5 6.589 5.411C7 5.822 7.434 6 8 6C8.566 6 9 5.822 9.411 5.411C9.822 5 10 4.566 10 4ZM2 14H7.503C7.516 13.002 7.787 12.035 8.319 11.169L8.336 11.141L8.423 11.008C8.282 11.003 8.141 11 8 11C7.059 11 6.133 11.11 5.221 11.331C4.313 11.551 3.41 11.882 2.511 12.33C2.364 12.408 2.246 12.514 2.142 12.685C2.047 12.839 2 12.997 2 13.2V14ZM12 4C12 5.1 11.609 6.042 10.825 6.825C10.042 7.609 9.1 8 8 8C6.9 8 5.958 7.609 5.175 6.825C4.392 6.042 4 5.1 4 4C4 2.9 4.392 1.958 5.175 1.175C5.958 0.391 6.9 0 8 0C9.1 0 10.042 0.391 10.825 1.175C11.609 1.958 12 2.9 12 4Z"
      fill="white"
    />
  </svg>
)

interface HlsParentalControlsButtonProps {
  enabled: boolean
  applied: number
  total: number
  onOpenModal: () => void
}

/**
 * Parental Controls button for the HLS.js player control bar.
 * Pauses playback, exits fullscreen, and triggers the parental controls modal
 * (owned by a parent component like CollectiblesPlayer).
 */
export const HlsParentalControlsButton: React.FC<HlsParentalControlsButtonProps> = ({
  enabled,
  applied,
  total,
  onOpenModal,
}) => {
  const track = useSafeTrack()
  const { controller } = useHlsPlayerUI()
  const { t } = useTranslate('common')

  const handleClick = () => {
    controller?.exitFullscreen()
    controller?.pause()
    onOpenModal()
    track('Clicked Parental Controls Bitmovin Player CTA Button')
  }

  const tooltipSubtitle =
    enabled && applied > 0 && total > 0
      ? t('parentalControlsAppliedDescription', '{{applied}} of {{total}} applied.', { applied, total })
      : t('parentalControlsDescription', 'Adjust parental control settings.')

  return (
    <button
      type="button"
      onClick={handleClick}
      className="group relative flex h-9 w-9 items-center justify-center rounded-full transition-colors hover:bg-white/20"
      aria-label={t('parentalControls', 'Parental Controls')}
    >
      {enabled ? <ParentalControlsOnIcon /> : <ParentalControlsOffIcon />}
      <HlsTooltip title={t('parentalControls', 'Parental Controls')} subtitle={tooltipSubtitle} />
    </button>
  )
}
